export default __webpack_public_path__ + "static/media/tsvetan_l.77435df9.jpg";